import React, { FC, memo } from 'react'
import type { Props } from '../types'

const Calendar: FC<Props> = ({ size = 16, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 14"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M.815 0A.824.824 0 0 0 0 .815v11.699c0 .443.372.815.815.815h13.37a.824.824 0 0 0 .815-.815V.815A.824.824 0 0 0 14.185 0H.815zm.591 3.719h12.188v8H1.406v-8z"
        fill="currentColor"
        fill-rule="evenodd"
      />
    </svg>
  )
}

export default memo(Calendar)
